import { combineEpics } from 'redux-observable';
import { getArtistAnalyticsEpic } from './get-artist-analytics';
import { resetOnLogoutEpic } from './reset-on-logout';
import { updateDSPsFromCategoriesEpic } from './update-dsps-from-categories';

const artistAnalyticsEpic = combineEpics(
  getArtistAnalyticsEpic,
  resetOnLogoutEpic,
  updateDSPsFromCategoriesEpic
);

export default artistAnalyticsEpic;
